export const removeFalsyKeys = (obj: Record<string, any>) => {
  Object.keys(obj).forEach((key) => {
    if (!obj[key]) {
      delete obj[key];
    }
  });
};
